import React, { useState, useRef, useEffect } from "react"; // Added useEffect
import { Container, Typography, Box, Grid, IconButton } from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import PauseIcon from "@mui/icons-material/Pause";
import ReplayIcon from "@mui/icons-material/Replay";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import styles from "./Voiceplots.module.css";
import Navbar from "../navbar/Navbar";
import chatWallImage from "../../asset/chatWall5.jpeg";
import Facilities from "../facilities/Facilities";
import ContextException from "../contextexception/ContextException";
import ContactUs from "../contact/ContactUs";
import Footer from "../footer/Footer";

// Audio Imports
import EnglishM from "../../asset/VoiceSamples/English(m).mp3";
import EnglishF from "../../asset/VoiceSamples/English(f).mp3";
import HindiM from "../../asset/VoiceSamples/Hindi(m).mp3";
import HindiF from "../../asset/VoiceSamples/Hindi(f).mp3";
import TamilM from "../../asset/VoiceSamples/Tamil(m).mp3";
import TamilF from "../../asset/VoiceSamples/Tamil(f).mp3";
import MarathiM from "../../asset/VoiceSamples/Marathi(m).mp3";
import MarathiF from "../../asset/VoiceSamples/Marathi(f).mp3";
import SpanishM from "../../asset/VoiceSamples/Spanish(m).mp3";
import SpanishF from "../../asset/VoiceSamples/Spanish(f).mp3";
import BengaliM from "../../asset/VoiceSamples/Bengali(m).mp3";
import BengaliF from "../../asset/VoiceSamples/Bengali(f).mp3";
import GujaratiM from "../../asset/VoiceSamples/Gujarati(m).mp3";
import GujaratiF from "../../asset/VoiceSamples/Gujarati(f).mp3";
import KannadaM from "../../asset/VoiceSamples/Kannada(m).mp3";
import KannadaF from "../../asset/VoiceSamples/Kannada(f).mp3";
import FrenchM from "../../asset/VoiceSamples/French(m).mp3";
import FrenchF from "../../asset/VoiceSamples/French(f).mp3";
import HebrewM from "../../asset/VoiceSamples/Hebrew(m).mp3";
import HebrewF from "../../asset/VoiceSamples/Hebrew(f).mp3";
import ItalianM from "../../asset/VoiceSamples/Italian(m).mp3";
import ItalianF from "../../asset/VoiceSamples/Italian(f).mp3";
import ArabicM from "../../asset/VoiceSamples/Arabic(m).mp3";
import ArabicF from "../../asset/VoiceSamples/Arabic(f).mp3";
import RussianM from "../../asset/VoiceSamples/Russian(m).mp3";
import RussianF from "../../asset/VoiceSamples/Russian(f).mp3";
import GermanM from "../../asset/VoiceSamples/German(m).mp3";
import GermanF from "../../asset/VoiceSamples/German(f).mp3";
import DutchM from "../../asset/VoiceSamples/Dutch(m).mp3";
import DutchF from "../../asset/VoiceSamples/Dutch(f).mp3";
import PolishM from "../../asset/VoiceSamples/Polish(m).mp3";
import PolishF from "../../asset/VoiceSamples/Polish(f).mp3";
import SwahiliM from "../../asset/VoiceSamples/Swahili(m).mp3";
import SwahiliF from "../../asset/VoiceSamples/Swahili(f).mp3";
import MalayalamM from "../../asset/VoiceSamples/Malayalam(m).mp3";
import MalayalamF from "../../asset/VoiceSamples/Malayalam(f).mp3";
import TeluguM from "../../asset/VoiceSamples/Telugu(m).mp3";
import TeluguF from "../../asset/VoiceSamples/Telugu(f).mp3"; 

const Voiceplots = () => {
  // 2. Set default to English
  const [selectedLang, setSelectedLang] = useState("English");
  const [isPlaying, setIsPlaying] = useState(false);
  const [activeGender, setActiveGender] = useState(null);
  const [activatedGender, setActivatedGender] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const audioRef = useRef(null);

  // 1. Updated audioMap with specific names for buttons
  const audioMap = {
    English: {
      m: { file: EnglishM, name: "James" },
      f: { file: EnglishF, name: "Emma" },
    },
    Marathi: {
      m: { file: MarathiM, name: "Shubham" },
      f: { file: MarathiF, name: "Sakshi" },
    },
    Hindi: {
      m: { file: HindiM, name: "Rahul" },
      f: { file: HindiF, name: "Ananya" },
    },
    Bengali: {
      m: { file: BengaliM, name: "Aarav" },
      f: { file: BengaliF, name: "Ishani" },
    },
    Dutch: {
      m: { file: DutchM, name: "Bram" },
      f: { file: DutchF, name: "Lotte" },
    },
    French: {
      m: { file: FrenchM, name: "Lucas" },
      f: { file: FrenchF, name: "Chloé" },
    },
    German: {
      m: { file: GermanM, name: "Maximilian" },
      f: { file: GermanF, name: "Hannah" },
    },
    Gujarati: {
      m: { file: GujaratiM, name: "Parth" },
      f: { file: GujaratiF, name: "Dhwani" },
    },
    Malayalam: {
      m: { file: MalayalamM, name: "Adithyan" },
      f: { file: MalayalamF, name: "Meera" },
    },
    Swahili: {
      m: { file: SwahiliM, name: "Mwanaume" },
      f: { file: SwahiliF, name: "Mwanamke" },
    },
    Hebrew: {
      m: { file: HebrewM, name: "Noam" },
      f: { file: HebrewF, name: "Maya" },
    },
    Italian: {
      m: { file: ItalianM, name: "Leonardo" },
      f: { file: ItalianF, name: "Giulia" },
    },
    Kannada: {
      m: { file: KannadaM, name: "Arjun" },
      f: { file: KannadaF, name: "Siri" },
    },
    Arabic: {
      m: { file: ArabicM, name: "Zaid" },
      f: { file: ArabicF, name: "Layla" },
    },
    Polish: {
      m: { file: PolishM, name: "Jakub" },
      f: { file: PolishF, name: "Zuzanna" },
    },
    Russian: {
      m: { file: RussianM, name: "Dmitry" },
      f: { file: RussianF, name: "Anastasia" },
    },
    Spanish: {
      m: { file: SpanishM, name: "Mateo" },
      f: { file: SpanishF, name: "Sofia" },
    },
    Telugu: {
      m: { file: TeluguM, name: "Rana" },
      f: { file: TeluguF, name: "Shwetha" },
    },
    Tamil: {
      m: { file: TamilM, name: "Karthik" },
      f: { file: TamilF, name: "Meena" },
    },
  };

  const handleDropdownClick = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const handleLanguageSelect = (lang) => {
    setDropdownOpen(false);
    if (audioRef.current) {
      audioRef.current.pause();
      setIsPlaying(false);
      setActiveGender(null);
      setActivatedGender(null);
    }
    setSelectedLang(lang);
  };

  const playAudio = (gender) => {
    const audioData = audioMap[selectedLang]?.[gender];

    if (audioData?.file && audioRef.current) {
      audioRef.current.src = audioData.file;
      audioRef.current
        .play()
        .then(() => {
          setIsPlaying(true);
          setActiveGender(gender);
          setActivatedGender(gender);
        })
        .catch((err) => console.error("Playback error:", err));
    }
  };

  const togglePause = (gender) => {
    if (!audioRef.current || activeGender !== gender) return;

    if (audioRef.current.paused) {
      audioRef.current.play();
      setIsPlaying(true);
    } else {
      audioRef.current.pause();
      setIsPlaying(false);
    }
  };

  const handleAudioEnded = () => {
    setIsPlaying(false);
    setActiveGender(null);
  };

  return (
    <div className={styles.voiceplotsPage}>
      <Navbar />
      <audio ref={audioRef} onEnded={handleAudioEnded} />

      <div className={styles.techBg}></div>

      <section className={styles.heroSection}>
        <Container maxWidth="lg" className={styles.heroContainer}>
          <span className={styles.titleIcon}>ㅤ</span>
          <Typography variant="h1" className={styles.heroTitle}>
            Voiceplots
          </Typography>
          <Typography variant="h2" className={styles.heroSubtitle}>
            Advanced Audio Analysis & Visualization Platform
          </Typography>
          <Typography variant="body1" className={styles.heroDescription}>
            Transforming raw audio data into meaningful insights through
            cutting-edge AI-powered analysis and interactive visualization
            tools.
          </Typography>

          <div className={styles.heroStats}>
            <div className={styles.statItem}>
              <Typography variant="h3" className={styles.statNumber}>
                99%
              </Typography>
              <Typography variant="body2" className={styles.statLabel}>
                Accuracy
              </Typography>
            </div>
            <div className={styles.statItem}>
              <Typography variant="h3" className={styles.statNumber}>
                Real-time
              </Typography>
              <Typography variant="body2" className={styles.statLabel}>
                Processing
              </Typography>
            </div>
            <div className={styles.statItem}>
              <Typography variant="h3" className={styles.statNumber}>
                15+
              </Typography>
              <Typography variant="body2" className={styles.statLabel}>
                Audio Formats
              </Typography>
            </div>
          </div>
        </Container>
      </section>

      <section className={styles.multilingualSection}>
        <Container maxWidth="xl">
          <Box
            className={styles.multilingualContainer}
            style={{
              backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.85), rgba(0, 0, 0, 0.85)), url(${chatWallImage})`,
            }}
          >
            <Typography variant="h3" className={styles.multilingualTitle}>
              Lifelike Voices in 15+ Global Languages
            </Typography>

            {selectedLang && (
              <Box className={styles.audioControlsContainer}>
                <Box className={styles.audioHeader}>
                  <Box className={styles.languageAvatar}>
                    <VolumeUpIcon className={styles.avatarIcon} />
                  </Box>

                  <Box className={styles.languageInfo}>
                    <Typography variant="h6" className={styles.selectedTitle}>
                      {selectedLang} Voice Samples
                    </Typography>
                    <Typography
                      variant="body2"
                      className={styles.languageSubtitle}
                    >
                      Experience high-quality voice output
                    </Typography>
                  </Box>
                  <Box className={styles.dropdownWithMenu}>
                    <IconButton
                      className={styles.dropdownIcon}
                      onClick={handleDropdownClick}
                      aria-label="Select Language"
                      sx={{ display: "flex", alignItems: "center" }} // Align items horizontally
                    >
                      <ArrowDropDownIcon />
                      <span
                        style={{
                          marginLeft: 8,
                          fontSize: "14px",
                          paddingtop: "14px",
                          fontWeight: 500,
                          fontFamily: "Raleway, Poppins, sans-serif",
                          // Hide text on mobile screens (max-width: 600px)
                          display: "inline-block",
                          "@media (max-width: 600px)": {
                            display: "none", 
                          },
                          "@media (max-width: 480px)": {
                            display: "none", 
                          },
                          "@media (max-width: 360px)": {
                            display: "none", // Hide text on mobile
                          },
                        }}
                      >
                        Select Language
                      </span>
                    </IconButton>

                    {dropdownOpen && (
                      <Box
                        className={`${styles.dropdownBox} ${
                          dropdownOpen ? styles.dropdownBoxOpen : ""
                        }`}
                      >
                        {dropdownOpen && (
                          <Box className={styles.dropdownMenuContainer}>
                            <Box className={styles.dropdownPaper}>
                              <Box className={styles.languageListContainer}>
                                {Object.keys(audioMap).map((lang) => (
                                  <Box
                                    key={lang}
                                    onClick={() => handleLanguageSelect(lang)}
                                    className={`${styles.dropdownMenuItem} ${
                                      selectedLang === lang
                                        ? styles.activeMenuItem
                                        : ""
                                    }`}
                                  >
                                    <Box className={styles.menuItemContent}>
                                      <Box>
                                        <VolumeUpIcon
                                          className={styles.menuItemIcon}
                                        />
                                      </Box>
                                      <Typography
                                        className={styles.menuItemText}
                                      >
                                        {lang}
                                      </Typography>
                                    </Box>
                                  </Box>
                                ))}
                              </Box>
                            </Box>
                          </Box>
                        )}
                      </Box>
                    )}
                  </Box>
                </Box>

                <Grid
                  container
                  spacing={3}
                  justifyContent="center"
                  className={styles.genderButtonsContainer}
                >
                  {["m", "f"].map((gender) => (
                    <Grid item key={gender}>
                      <Box className={styles.audioActionRow}>
                        <button
                          className={styles.genderButton}
                          onClick={() => playAudio(gender)}
                        >
                          {/* Show dynamic name  */}
                          {audioMap[selectedLang][gender].name}
                        </button>

                        <Box
                          className={`${styles.miniControls} ${
                            activatedGender === gender
                              ? styles.miniControlsVisible
                              : ""
                          }`}
                        >
                          <IconButton
                            onClick={() => togglePause(gender)}
                            className={styles.controlIcon}
                          >
                            {isPlaying && activeGender === gender ? (
                              <PauseIcon />
                            ) : (
                              <PlayArrowIcon />
                            )}
                          </IconButton>
                          <IconButton
                            onClick={() => playAudio(gender)}
                            className={styles.controlIcon}
                          >
                            <ReplayIcon />
                          </IconButton>
                        </Box>
                      </Box>
                    </Grid>
                  ))}
                </Grid>
              </Box>
            )}
          </Box>
        </Container>
      </section>

      <Facilities />
      <ContextException />
      <ContactUs />
      <Footer />
    </div>
  );
};

export default Voiceplots;
